// Ignore asynchronous refresh responses superseded by logout or a new login.
let generation = 0;
let paused = false;

export const getAuthGeneration = () => generation;
export const isRefreshPaused = () => paused;
export const pauseRefresh = () => { paused = true; generation += 1; };
export const resumeRefresh = () => { paused = false; generation += 1; };
